import { useMemo } from "react";
import { useLayerCulling } from "./useLayerCulling";

const EMPTY_ITEMS: readonly never[] = [];

export function useMapLayer<TItem extends { id: string }>({
    items,
    selectedIds,
}: {
    items?: readonly TItem[];
    selectedIds?: ReadonlySet<string>;
}) {
    const layerItems: readonly TItem[] = items ?? EMPTY_ITEMS;
    useLayerCulling(layerItems);

    const itemsById = useMemo(
        () => new Map(layerItems.map((item) => [item.id, item])),
        [layerItems],
    );
    const selectedItems = useMemo(() => {
        if (!selectedIds) return [];

        return Array.from(selectedIds, (id) => itemsById.get(id)).filter(
            (item): item is TItem => item !== undefined,
        );
    }, [itemsById, selectedIds]);

    return { items: layerItems, itemsById, selectedItems };
}
